import { Button } from 'primereact/button';
import { BasicSelectComponent } from '../../../../components/BasicSelectComponentComponent';
import { IReassigmentProvider } from '../../../../interfaces/service/ReassignmentServiceManagerInterface';
import {
  IFormInformation,
  IReassignmentDataToSend,
} from '../../../../interfaces/interfaceReassignment';

interface ISamForm {
  serviceReassignment: IReassigmentProvider;
}

export const SamForm = (props: ISamForm) => {
  const { serviceReassignment } = props;

  const renderReasonInput = () => {
    if (serviceReassignment.formDeviceSelected !== '') {
      return (
        <div className="flex flex-col w-full pl-5 my-2">
          <label htmlFor="reasonInput" className="font-bold text-grey">
            Comentario de Reasignación
          </label>
          <textarea
            id="reasonInput"
            className="border border-grey rounded-md p-2 mt-2 w-[90%] resize-none"
            placeholder="Comenta la razón de reasignación"
            name="reason"
            rows={3}
            onChange={serviceReassignment.handleReasonChange}
          />
        </div>
      );
    }
    return null;
  };

  const renderSelects = () => {
    return (
      <div className="flex flex-col w-full pl-5 ">
        {serviceReassignment.deviceFormInfo.map((field: IFormInformation) => {
          return (
            <div key={field.name} className="mt-3">
              <span className="font-bold text-grey ">{field.label}</span>
              <BasicSelectComponent
                name={field.name}
                optionLabel={field.optionLabel}
                optionValue={field.optionValue}
                options={serviceReassignment.selectDeviceData[field.options]}
                disabled={
                  field.disabled &&
                  (serviceReassignment.dataToSend[
                    field.disabledValue as keyof IReassignmentDataToSend
                  ] === undefined ||
                    serviceReassignment.dataToSend[
                      field.disabledValue as keyof IReassignmentDataToSend
                    ] === null ||
                    serviceReassignment.dataToSend[
                      field.disabledValue as keyof IReassignmentDataToSend
                    ] === '')
                }
                classNames="w-[90%]"
                onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                  serviceReassignment.handleSelectChange(
                    e.target.name as keyof IReassignmentDataToSend,
                    Number(e.target.value)
                  )
                }
              />
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div className="flex flex-col h-full w-full">
      {/* Contenedor con scroll */}
      <div className="flex-1 overflow-y-auto">
        <div className="flex flex-col w-full pl-5 my-2 ">
          <label htmlFor="samId" className="font-bold text-grey">
            SAM ID
          </label>
          <span
            id="samId"
            className="truncate max-w-full ms-3"
            title={serviceReassignment.dataRow.SamId}>
            {serviceReassignment.truncateText(
              serviceReassignment.dataRow.SamId
            )}
          </span>
        </div>

        <div className="flex flex-col w-full pl-5 my-2">
          <label htmlFor="samType" className="font-bold text-grey">
            Tipo SAM
          </label>
          <span
            id="samType"
            className="truncate max-w-full ms-3"
            title={serviceReassignment.dataRow.SamTypeName}>
            {serviceReassignment.truncateText(
              serviceReassignment.dataRow.SamTypeName
            )}
          </span>
        </div>

        <div className="flex flex-col w-full pl-5 my-2">
          <span className="font-bold text-grey">Tipo de Equipo</span>
          <BasicSelectComponent
            name="TE"
            optionLabel="DeviceTypeName"
            optionValue="DeviceTypeEnum"
            options={serviceReassignment.availableDeviceSam}
            classNames="w-[90%]"
            onChange={(event: React.ChangeEvent<HTMLSelectElement>) =>
              serviceReassignment.onFormDeviceTypeChange(
                Number(event.target.value)
              )
            }
          />
        </div>

        {renderSelects()}
        {renderReasonInput()}
      </div>

      {/* Botones siempre abajo */}
      <div className="flex w-full items-center justify-center p-3 border-t border-gray-300">
        <div className="mx-1">
          <Button onClick={serviceReassignment.closeRightMenu}>Cancelar</Button>
        </div>
        <div className="mx-1">
          <Button onClick={serviceReassignment.onSubmit}>Reasignar</Button>
        </div>
      </div>
    </div>
  );
};
